import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-modulelistnav',
  templateUrl: './modulelistnav.component.html',
  styleUrls: ['./modulelistnav.component.css']
})
export class ModulelistnavComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
